import React, { useEffect, useRef, useState, useContext } from "react";
import { Link } from "gatsby";
import PubSub from "pubsub-js";
import clsx from "clsx";
import Cart from "./shop/Cart";
import MenuShopMobile from "./MenuShopMobile";
import { WrapperContext } from "./Layout";

// const MenuItem = ({ li,i }) => (
//   <li key={i} className='menu-item  text-sm-lg md:text-base'>
//     <Link to={getLink(li.link)}>{li.label}</Link>
//   </li>
// );
// const MenuItemShop = ({ li, i }) => (
//   <li
//     className={clsx(
//       "menu-item menu-item-shop text-sm-lg md:text-base",
//       menuShopActive ? "is-active" : ""
//     )}>
//     <button
//       onClick={() => setMenuShopActive(!menuShopActive)}
//       aria-label='open shop menu'>
//       <span>Shop</span>
//       <span className='ico-close'>×</span>
//     </button>

//     <div className='sm-only'>
//       <MenuShopMobile />
//     </div>
//   </li>
// );

const Menu = ({ input }) => {
  const { isMobile } = useContext(WrapperContext);
  const menuWrap = useRef();
  const [smMenuActive, setSmMenuActive] = useState();
  const [menuShopActive, setMenuShopActive] = useState(false);
  // console.log("isMobile", isMobile);
  useEffect(() => {
    const token = PubSub.subscribe("ITEM.ADDED", (e, d) => {
      setSmMenuActive(true);
    });

    return () => PubSub.unsubscribe(token);
  }, []);
  useEffect(() => {
    const token = PubSub.subscribe("ROUTE_UPDATE", e => {
      console.log(e);
      console.log("isMobile", isMobile);
      if (isMobile) setSmMenuActive(false);
    });

    return () => PubSub.unsubscribe(token);
  }, [isMobile]);

  const _toggleMenu = () => {
    console.log("smMenuActive", smMenuActive);
    setSmMenuActive(!smMenuActive);
  };

  useEffect(() => {
    PubSub.publish("MENU_SHOP_ACTIVE", menuShopActive);
  }, [menuShopActive]);

  const getLink = node => (node.home ? "/" : `/${node.slug.current}`);

  const _menuItems = input.filter(el => el.rel !== "shop");
  const _menuItemShop = input.filter(el => el.rel === "shop");

  return (
    <nav className='menu-header'>
      <button className='sm-only w-60' onClick={() => _toggleMenu()}>
        {smMenuActive ? "Fermer" : "Menu"}
      </button>
      <div
        className={clsx("menu-wrap", smMenuActive ? "is-active" : "")}
        ref={menuWrap}>
        <div className='sm-only absolute right-sm'>
          <Cart />
        </div>

        <ul className='flex flex-col md:flex-row '>
          {_menuItems.map((li, i) => (
            <li key={i} className='menu-item  text-sm-lg md:text-base'>
              <Link to={getLink(li.link)}>{li.label}</Link>
            </li>
          ))}
          {_menuItemShop.map((li, i) => (
            <li
              key={i}
              className={clsx(
                "menu-item menu-item-shop text-sm-lg md:text-base",
                menuShopActive ? "is-active" : ""
              )}>
              <button
                //to={getLink(li.link)}
                onClick={() => setMenuShopActive(!menuShopActive)}>
                <span>{li.label}</span>
                <span className='ico-close'>×</span>
              </button>

              <div className='sm-only'>
                <MenuShopMobile />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};
export default Menu;
